import type { SvgIconProps } from "./SVGIcon";
import SVGIcon from "./SVGIcon";

export default function IconTooltip(props: SvgIconProps) {
  return (
    <SVGIcon width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M13 3.5H3.5V13" stroke="currentColor" />
      <path d="M10 14.5H5.5V5.5H14.5V10" stroke="currentColor" />
      <path d="M10 12.5H15" stroke="currentColor" />
      <path d="M12.5 10V15" stroke="currentColor" />
    </SVGIcon>
  );
}
